import { render, staticRenderFns } from "./ImpressaoRelatorioBoleado.vue?vue&type=template&id=74f4cacf&scoped=true&"
import script from "./ImpressaoRelatorioBoleado.vue?vue&type=script&lang=js&"
export * from "./ImpressaoRelatorioBoleado.vue?vue&type=script&lang=js&"
import style0 from "./ImpressaoRelatorioBoleado.vue?vue&type=style&index=0&id=74f4cacf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f4cacf",
  null
  
)

export default component.exports